(function () {
  'use strict';

  /* ---------- Pengar ---------- */
  function num(cents, dec, th, d) {
    var parts = (cents / 100).toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return dec ? parts[0] + d + parts[1] : parts[0];
  }
  function money(cents) {
    var f = window.ThemeMoney || '{{amount_with_comma_separator}} kr';
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = num(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = num(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = num(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = num(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = num(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': v = num(cents, 2, "'", '.'); break;
      default: v = num(cents, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }

  /* ---------- Meny ---------- */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Produktsida ---------- */
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var form = document.getElementById(root.dataset.formId);
    var pj = root.querySelector('[data-product-json]');
    if (!form || !pj) return;
    var product = JSON.parse(pj.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variant = product.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || product.variants[0];
    var qty = 1;

    // Galleri
    var slides = [].slice.call(root.querySelectorAll('.pdp__slide'));
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    var current = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === current);
        if (k !== current) { var v = s.querySelector('video'); if (v) v.pause(); }
      });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === current);
        t.setAttribute('aria-current', k === current ? 'true' : 'false');
      });
      var t = thumbs[current];
      if (t && t.parentNode) {
        var row = t.parentNode;
        var left = t.offsetLeft - row.offsetLeft;
        if (left < row.scrollLeft || left + t.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    show(current < 0 ? 0 : current);
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    function showMedia(id) {
      var k = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
      if (k > -1) show(k);
    }

    var stickySel = document.querySelector('[data-sticky-variant]');
    var stickyQty = document.querySelector('[data-sticky-qty]');

    // Paket (antal)
    var bundles = [].slice.call(root.querySelectorAll('[data-bundle]'));
    var picker = root.querySelector('[data-variant-picker]');
    function selectBundle(card) {
      bundles.forEach(function (b) {
        var on = b === card;
        b.classList.toggle('is-active', on);
        b.querySelector('.bundle__radio').checked = on;
      });
      qty = parseInt(card.dataset.qty, 10) || 1;
      qtyInput.value = qty;
      if (stickyQty) stickyQty.value = qty;
      var slot = card.querySelector('[data-bundle-slot]');
      if (picker && slot && picker.parentNode !== slot) slot.insertBefore(picker, slot.firstChild);
      buildExtras(card, qty);
      render();
    }
    bundles.forEach(function (b) {
      b.querySelector('.bundle__radio').addEventListener('change', function () { selectBundle(b); });
      b.addEventListener('click', function (e) {
        if (e.target.closest('[data-bundle-slot]')) return;
        if (!b.classList.contains('is-active')) selectBundle(b);
      });
    });

    // Paket: välj färg/lagring per konsol
    var extras = []; // selections for item 2..n, arrays of option values
    function mainSel() { return variant ? variant.options.slice() : product.variants[0].options.slice(); }
    function findVariant(opts) { return product.variants.filter(function (v) { return v.options.every(function (o, k) { return o === opts[k]; }); })[0] || null; }
    function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function buildExtras(card, n) {
      root.querySelectorAll('[data-bundle-extra]').forEach(function (el) { el.remove(); });
      if (product.options.length === 0 || (product.variants.length < 2)) return;
      while (extras.length < n - 1) extras.push(mainSel());
      extras.length = Math.max(0, n - 1);
      if (n < 2) return;
      var slot = card.querySelector('[data-bundle-slot]');
      var wrap = document.createElement('div');
      wrap.className = 'bx'; wrap.setAttribute('data-bundle-extra', '');
      var html = '<p class="bx__lead">Konsol 1 väljer du ovan. Välj för resten:</p>';
      for (var i = 0; i < n - 1; i++) {
        html += '<div class="bx__row" data-bx="' + i + '"><span class="bx__n">Konsol ' + (i + 2) + '</span>';
        product.options.forEach(function (oname, oi) {
          var vals = [];
          product.variants.forEach(function (v) { if (vals.indexOf(v.options[oi]) < 0) vals.push(v.options[oi]); });
          html += '<label class="bx__f"><span class="visually-hidden">' + esc(oname) + ' för konsol ' + (i + 2) + '</span><select class="bx__sel" data-bx-opt="' + oi + '">';
          vals.forEach(function (val) { html += '<option value="' + esc(val) + '"' + (extras[i][oi] === val ? ' selected' : '') + '>' + esc(val) + '</option>'; });
          html += '</select></label>';
        });
        html += '</div>';
      }
      wrap.innerHTML = html;
      slot.appendChild(wrap);
      wrap.querySelectorAll('[data-bx]').forEach(function (row) {
        var i = parseInt(row.dataset.bx, 10);
        row.querySelectorAll('[data-bx-opt]').forEach(function (sel) {
          sel.addEventListener('change', function () { extras[i][parseInt(sel.dataset.bxOpt, 10)] = sel.value; render(); });
        });
      });
    }
    function bundleItems() {
      var list = [variant];
      for (var i = 0; i < qty - 1 && i < extras.length; i++) list.push(findVariant(extras[i]));
      while (list.length < qty) list.push(variant);
      return list;
    }

    // Varianter
    var radios = [].slice.call(root.querySelectorAll('[data-opt-index]'));
    function selectedOptions() {
      var sel = [];
      radios.forEach(function (r) { if (r.checked) sel[parseInt(r.dataset.optIndex, 10)] = r.value; });
      return sel;
    }
    function markUnavailable() {
      var sel = selectedOptions();
      radios.forEach(function (r) {
        var i = parseInt(r.dataset.optIndex, 10);
        var test = sel.slice(); test[i] = r.value;
        var ok = product.variants.some(function (v) {
          return v.available && v.options.every(function (o, k) { return k === i ? o === r.value : (test[k] === undefined || o === test[k]); });
        });
        r.closest('.vp__val').classList.toggle('is-unavailable', !ok);
      });
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = selectedOptions();
        root.querySelectorAll('[data-opt-label]').forEach(function (l) { l.textContent = sel[parseInt(l.dataset.optLabel, 10)] || ''; });
        var v = product.variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0] || null;
        variant = v;
        if (v) {
          idInput.value = v.id;
          if (stickySel) stickySel.value = v.id;
          if (v.featured_media) showMedia(v.featured_media.id);
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
        }
        markUnavailable();
        render();
      });
    });
    if (radios.length) markUnavailable();

    // Fast köprad: variant och antal
    if (stickySel) {
      stickySel.addEventListener('change', function () {
        var v = product.variants.filter(function (x) { return String(x.id) === stickySel.value; })[0];
        if (!v) return;
        var last = null;
        radios.forEach(function (r) {
          var on = v.options[parseInt(r.dataset.optIndex, 10)] === r.value;
          r.checked = on;
          if (on) last = r;
        });
        if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function setQty(n) {
      n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
      var match = bundles.filter(function (b) { return parseInt(b.dataset.qty, 10) === n; })[0];
      if (match) { selectBundle(match); return; }
      bundles.forEach(function (b) { b.classList.remove('is-active'); b.querySelector('.bundle__radio').checked = false; });
      qty = n; qtyInput.value = n;
      if (stickyQty) stickyQty.value = n;
      render();
    }
    if (stickyQty) {
      stickyQty.addEventListener('change', function () { setQty(stickyQty.value); });
      document.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () { setQty((parseInt(stickyQty.value, 10) || 1) + parseInt(b.dataset.step, 10)); });
      });
    }

    function render() {
      var atcs = [].slice.call(document.querySelectorAll('[data-atc], [data-sticky-atc]'));
      var atcText = root.querySelector('[data-atc-text]');
      var atcMain = root.querySelector('[data-atc]');
      var stock = root.querySelector('[data-stock]');
      if (!variant) {
        atcs.forEach(function (b) { b.disabled = true; });
        if (atcText) atcText.textContent = 'Inte tillgänglig';
        if (stock) { stock.classList.add('is-out'); stock.textContent = stock.dataset.out; }
        return;
      }
      var items = bundleItems();
      var allOk = items.every(function (v) { return v && v.available; });
      var avail = variant.available && allOk;
      atcs.forEach(function (b) { b.disabled = !avail; });
      if (atcText && atcMain) atcText.textContent = avail ? atcMain.dataset.label : 'Slutsåld';
      if (stock) { stock.classList.toggle('is-out', !avail); stock.textContent = avail ? stock.dataset.in : stock.dataset.out; }

      var unitCmp = Math.max(variant.compare_at_price || 0, variant.price);
      root.querySelectorAll('[data-bx]').forEach(function (row) {
        var v = items[parseInt(row.dataset.bx, 10) + 1];
        row.classList.toggle('is-out', !(v && v.available));
      });
      var selectedTotal = variant.price * qty;
      bundles.forEach(function (card) {
        var n = parseInt(card.dataset.qty, 10) || 1;
        var d = parseInt(card.dataset.discount, 10) || 0;
        var base = variant.price * n, cmp = unitCmp * n;
        if (n === qty) {
          base = 0; cmp = 0;
          items.forEach(function (v) { var vv = v || variant; base += vv.price; cmp += Math.max(vv.compare_at_price || 0, vv.price); });
        }
        var now = Math.round(base * (100 - d) / 100);
        card.querySelector('[data-bprice]').textContent = money(now);
        card.querySelector('[data-bcompare]').textContent = cmp > now ? money(cmp) : '';
        if (n === qty) selectedTotal = now;
      });
      var p = root.querySelector('[data-price]'); if (p) p.textContent = money(variant.price);
      var c = root.querySelector('[data-compare]'); if (c) c.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(selectedTotal);
      var addSum = 0;
      root.querySelectorAll('[data-addon]:checked').forEach(function (x) { addSum += parseInt(x.dataset.addonP, 10) || 0; });
      var ap = root.querySelector('[data-atc-price]');
      if (ap) { ap.textContent = money(selectedTotal + addSum); ap.parentNode.classList.toggle('is-out', !avail); }
    }
    if (bundles.length) selectBundle(bundles[0]); else render();


    // Förstora bild
    var lb = root.querySelector('[data-lightbox]');
    var zoomBtn = root.querySelector('[data-zoom]');
    if (lb && zoomBtn) {
      var lbImg = lb.querySelector('[data-lb-img]');
      var closeLb = function () { lb.hidden = true; document.body.style.overflow = ''; zoomBtn.focus(); };
      zoomBtn.addEventListener('click', function () {
        var s = slides[current]; if (!s) return;
        var src = s.dataset.zoomSrc;
        if (!src) { var im = s.querySelector('img'); src = im && (im.currentSrc || im.src); }
        if (!src) return;
        lbImg.src = src; lb.hidden = false; document.body.style.overflow = 'hidden';
        lb.querySelector('[data-lb-close]').focus();
      });
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-lb-close]')) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          show(current + (e.key === 'ArrowRight' ? 1 : -1));
          var s = slides[current]; if (s && s.dataset.zoomSrc) lbImg.src = s.dataset.zoomSrc;
        }
      });
    }

    // Jämför färger
    var cmp = root.querySelector('[data-compare]');
    var cmpOpen = root.querySelector('[data-compare-open]');
    if (cmp && cmpOpen) {
      var closeCmp = function () { cmp.hidden = true; document.body.style.overflow = ''; cmpOpen.focus(); };
      cmpOpen.addEventListener('click', function () { cmp.hidden = false; document.body.style.overflow = 'hidden'; cmp.querySelector('[data-compare-close]').focus(); });
      cmp.addEventListener('click', function (e) {
        if (e.target === cmp || e.target.closest('[data-compare-close]')) { closeCmp(); return; }
        var item = e.target.closest('[data-compare-pick]');
        if (!item) return;
        var idx = item.dataset.compareIndex, val = item.dataset.comparePick;
        var r = radios.filter(function (x) { return x.dataset.optIndex === idx && x.value === val; })[0];
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
        closeCmp();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cmp.hidden) closeCmp(); });
    }

    // Dela
    var shareBtn = root.querySelector('[data-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = shareBtn.dataset.url, txt = shareBtn.querySelector('[data-share-text]');
        if (navigator.share) { navigator.share({ title: shareBtn.dataset.title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
          txt.textContent = 'Länken kopierad'; setTimeout(function () { txt.textContent = 'Dela'; }, 2000);
        });
      });
    }

    root.querySelectorAll('[data-addon]').forEach(function (x) { x.addEventListener('change', render); });

    // Köps ofta tillsammans: variantval
    root.querySelectorAll('[data-addon-row]').forEach(function (row) {
      var sel = row.querySelector('[data-addon-select]');
      if (!sel) return;
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var price = parseInt(o.dataset.price, 10) || 0, cmpP = parseInt(o.dataset.compare, 10) || 0;
        row.querySelector('[data-addon]').dataset.addon = sel.value;
        row.querySelector('[data-addon]').dataset.addonP = price;
        render();
        row.querySelector('[data-addon-price]').textContent = money(price);
        row.querySelector('[data-addon-compare]').textContent = cmpP > price ? money(cmpP) : '';
        row.querySelector('[data-addon-save]').textContent = cmpP > price ? 'Spara ' + money(cmpP - price) + '!' : '';
      });
    });

    // Tillbehör: lägg till allt i ett anrop
    form.addEventListener('submit', function (e) {
      var addons = [].slice.call(root.querySelectorAll('[data-addon]:checked'));
      var mixed = qty > 1 && root.querySelector('[data-bundle-extra]');
      if ((!addons.length && !mixed) || !window.fetch) return;
      e.preventDefault();
      var btn = root.querySelector('[data-atc]');
      if (btn) btn.classList.add('is-busy');
      var items = [];
      if (mixed) {
        var counts = {}, order = [];
        bundleItems().forEach(function (v) { var id = (v || variant).id; if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
        order.forEach(function (id) { items.push({ id: id, quantity: counts[id] }); });
      } else {
        items.push({ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 });
      }
      items = items.concat(addons.map(function (x) { return { id: parseInt(x.dataset.addon, 10), quantity: 1 }; }));
      var routes = window.ThemeRoutes || { cart: '/cart', cartAdd: '/cart/add' };
      fetch(routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = routes.cart;
      }).catch(function () {
        if (btn) btn.classList.remove('is-busy');
        HTMLFormElement.prototype.submit.call(form);
      });
    });

    // Leveransdatum (arbetsdagar)
    root.querySelectorAll('[data-delivery]').forEach(function (el) {
      var months = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
      function add(n) {
        var d = new Date(); var k = 0;
        while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
        return d;
      }
      function fmt(d) { return d.getDate() + ' ' + months[d.getMonth()]; }
      function range(a, b) { a = parseInt(a, 10) || 0; b = Math.max(a, parseInt(b, 10) || 0); return a === b ? fmt(add(a)) : fmt(add(a)) + ' – ' + fmt(add(b)); }
      el.querySelector('[data-dd0]').textContent = fmt(new Date());
      el.querySelector('[data-dd1]').textContent = range(el.dataset.s1, el.dataset.s2);
      el.querySelector('[data-dd2]').textContent = range(el.dataset.d1, el.dataset.d2);
    });

    // Fast köprad
    var sticky = document.querySelector('[data-sticky]');
    var atcBtn = root.querySelector('[data-atc]');
    if (sticky && atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(atcBtn);
    }
  });

  /* ---------- Rabattflik ---------- */
  var nt = document.querySelector('[data-nt]');
  if (nt) {
    var panel = nt.querySelector('[data-nt-panel]');
    var opener = nt.querySelector('[data-nt-open]');
    var openNt = function () { panel.hidden = false; var f = panel.querySelector('input[type=email], [data-nt-close]'); if (f) f.focus(); };
    var closeNt = function () { panel.hidden = true; opener.focus(); };
    opener.addEventListener('click', openNt);
    nt.querySelector('[data-nt-close]').addEventListener('click', closeNt);
    panel.addEventListener('click', function (e) { if (e.target === panel) closeNt(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closeNt(); });
    if (panel.querySelector('[data-nt-success], .errors') || /customer_posted=true/.test(location.search)) openNt();
  }
})();

/* ---------- Videor spelas automatiskt (utan ljud) när de syns ---------- */
(function () {
  var vids = [].slice.call(document.querySelectorAll('video'));
  if (!vids.length) return;
  function prep(v) {
    v.muted = true; v.defaultMuted = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.autoplay = true; v.loop = true;
  }
  function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  vids.forEach(function (v) {
    prep(v);
    // Om kunden själv pausar respekteras det
    v.addEventListener('pause', function () { if (v.dataset.autoPausing === '1') { delete v.dataset.autoPausing; return; } if (!v.ended) v.dataset.userPaused = '1'; });
    v.addEventListener('play', function () { delete v.dataset.userPaused; });
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (!v.dataset.userPaused) tryPlay(v); }
        else if (!v.paused) { v.dataset.autoPausing = '1'; v.pause(); }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  } else {
    vids.forEach(tryPlay);
  }
  // Vissa mobiler kräver en första interaktion – starta då synliga videor
  var kick = function () {
    vids.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (v.paused && !v.dataset.userPaused && r.bottom > 0 && r.top < innerHeight) tryPlay(v);
    });
    ['touchstart', 'scroll', 'click'].forEach(function (t) { removeEventListener(t, kick, true); });
  };
  ['touchstart', 'scroll', 'click'].forEach(function (t) { addEventListener(t, kick, { capture: true, passive: true }); });
})();
